import { queryOptions } from "@tanstack/react-query";

import type { SessionResponse } from "@learn-flow/contracts";

import { ApiError, apiRequest } from "../../lib/api.js";

export const sessionQueryKey = ["session"] as const;

export const sessionQueryOptions = queryOptions({
  queryKey: sessionQueryKey,
  queryFn: async () => {
    try {
      return await apiRequest<SessionResponse>("/api/v1/auth/session");
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) return null;
      throw error;
    }
  },
  staleTime: 30_000,
  retry: false,
});
